<template>
  <NodePageLanding v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'Homepage',
})

definePageMeta({
  name: 'home',
  hideBreadcrumb: true,
})

const { entity: node } = await useDrupalRouteQuery('nodePage')

await renderPageDependencies()
</script>
